/* Garden Party LP — shared behavior: reveal-on-scroll + FAQ accordion.
   Loaded (defer) by every garden-party-* section; the window.__gpJsLoaded guard
   makes duplicate <script> tags a no-op, and element-level data flags make init
   idempotent. Re-inits on shopify:section:load for the theme editor. */
(function () {
  if (window.__gpJsLoaded) return;
  window.__gpJsLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(els) {
    els.forEach(function (el) { el.classList.add('gp-in'); });
  }

  function init(scope) {
    var root = scope || document;

    // Reveal-on-scroll
    var els = Array.prototype.filter.call(root.querySelectorAll('.gp-editorial .gp-reveal'), function (el) {
      return el.dataset.gpRevealInit !== '1';
    });
    els.forEach(function (el) { el.dataset.gpRevealInit = '1'; });
    if (els.length) {
      if (!('IntersectionObserver' in window) || reduceMotion) {
        revealAll(els);
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('gp-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px', threshold: 0.05 });
        els.forEach(function (el) { io.observe(el); });
        // Safety net: reveal anything the observer hasn't fired for after 1.5s.
        setTimeout(function () { revealAll(els); }, 1500);
      }
    }

    // FAQ accordion (one open at a time within a list)
    root.querySelectorAll('.gp-editorial .gp-faq-list').forEach(function (list) {
      if (list.dataset.gpFaqInit === '1') return;
      list.dataset.gpFaqInit = '1';
      list.querySelectorAll('.gp-faq-item').forEach(function (item) {
        var btn = item.querySelector('.gp-faq-q');
        var panel = item.querySelector('.gp-faq-a');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('gp-open');
          list.querySelectorAll('.gp-faq-item.gp-open').forEach(function (other) {
            other.classList.remove('gp-open');
            other.querySelector('.gp-faq-a').style.maxHeight = null;
            other.querySelector('.gp-faq-q').setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('gp-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
